import handleResponse from "../utils/handleresponse";

export const partnerService = {
    getPartnerList
};

function getPartnerList() {
    return fetch(`${process.env.REACT_APP_API_URL}/users/partners/`)
        .then(handleResponse)
        .then(partners=>{
            return partners.data;
        })
}

